import * as caretakerListManager from '$domain/model/caretaker/caretakerList/caretakerList.manager'

export const getCaretakerList = (latitude: number, longitude: number, limit?: number, offset?: number) =>
  caretakerListManager.getCaretakerList(latitude, longitude, limit, offset)



// WEBPACK FOOTER //
// ./src/services/caretaker/caretakerList/caretakerList.service.ts